// extracted by mini-css-extract-plugin
module.exports = {"header":"SelectingDateRange_header_1OYIj","title":"SelectingDateRange_title_27RAF","footer":"SelectingDateRange_footer_UAt6L"};